import { __rest, __assign } from 'tslib';
import React from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';

// TODO: Connect aria-labelledby to Title in CardHeader, if present
// TODO: Create an API to easily connect aria-describedby.
var shadowVariants = {
    none: "tw-shadow-none",
    "default": "tw-shadow",
    sm: "tw-shadow-sm",
    md: "tw-shadow-md",
    lg: "tw-shadow-lg",
    xl: "tw-shadow-xl",
    xxl: "tw-shadow-2xl"
};
function getShadowClassName(shadow) {
    if (typeof shadow === "boolean") {
        return shadow ? shadowVariants["default"] : shadowVariants.none;
    }
    return shadowVariants[shadow];
}
/**
 * This component should be used to house similar information or data.
 * It may be used for widgets on a dashboard, data visualizations or data
 * counters, or sections on a page or in a form. These components can be
 * used together to segment the information on a page.
 *
 * Use the CardHeader, CardBody, and CardFooter components for the standard style and behavior. Each are exported from the root:
 *
 * ### Import Guide
 *
 * ```jsx
 * import { Card, CardBody, CardFooter, CardHeader } from '@panwds/react-ui';
 * ```
 */
function Card(_a) {
    var addClassName = _a.addClassName, children = _a.children, dataMetrics = _a.dataMetrics, dataTestId = _a.dataTestId, _b = _a.shadow, shadow = _b === void 0 ? false : _b, _c = _a.style, style = _c === void 0 ? {} : _c, passThrough = __rest(_a, ["addClassName", "children", "dataMetrics", "dataTestId", "shadow", "style"]);
    var className = classNames("tw-flex tw-flex-col tw-border tw-box-border tw-border-solid tw-border-gray-300 tw-rounded tw-bg-white", "dark:tw-bg-gray-1000 dark:tw-border-gray-700", getShadowClassName(shadow), addClassName);
    return (React.createElement("div", __assign({ "data-metrics": dataMetrics, "data-testid": dataTestId || "card", style: style, className: className }, passThrough), children));
}

export { Card };
//# sourceMappingURL=Card.esm.js.map
